'use client'
import { useState } from 'react'
import { TranslationIssueFormModal } from './TranslationIssueFormModal'
import { Banner, Hyperlink, Thumbnail, ThumbnailRatio, ThumbnailSize } from '@/tools/ui'

export const TranslationIssueBanner = ({ className }: { className: string }) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const handleTranslationIssueClick = () => {
    setShowModal(true)
  }
  const handleClose = () => setShowModal(false)
  return (
    <>
      <Banner
        accessory={
          <Thumbnail
            alt=""
            ratio={ThumbnailRatio.ratio1x1}
            size={ThumbnailSize.xxxsmall}
            src="https://glovoapp.com/images/translation-reporting.png"
          />
        }
        className={className}
        description="Notice a translation issue? Help by reporting."
        link={
          <Hyperlink
            href="#"
            label="Report issue by clicking here"
            onClick={handleTranslationIssueClick}
          />
        }
      />
      <TranslationIssueFormModal isOpen={showModal} onClose={handleClose} />
    </>
  )
}
